<template>
  <v-card :loading="loading" :disabled="loading">
    <v-card-title>
      <span class="headline">{{ $t('rooms.form.formTitle') }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-form v-if="dialog" ref="form" v-model="valid" lazy-validation autocomplete="off">
          <div v-if="error">{{ $t('rooms.form.formError') }}</div>
          <div v-else-if="!error">
            <v-row>
              <v-col cols="12">
                <SelectFieldStock v-on:change-value="changeValue" :owners="labelsOwner" :displayLabel="true" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <InputField
                  name="name"
                  :label="$t('rooms.form.descriptionLabel') + ' *'"
                  :value="name"
                  v-on:input-change="changeValue"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <DatepickerOfRoom
                  :label="$t('rooms.form.dateLabel') + ' *'"
                  :hint="$t('rooms.form.hintDate')"
                  v-on:save-date="changeValue"
                  :value="date"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <TimepickerOfRoom
                  :label="$t('rooms.form.hourLabel') + ' *'"
                  v-on:save-time="changeValue"
                  :value="time"
                />
              </v-col>
            </v-row>
            <small>*{{ $t('rooms.form.required') }}</small>
          </div>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="reset">{{ $t('rooms.form.cancel') }}</v-btn>
      <v-btn color="primary" text @click="validate">{{ $t('rooms.form.create') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import InputField from '@/components/common/atoms/InputField.vue'
import DatepickerOfRoom from '@/components/rooms/form/inputs/DatepickerOfRoom.vue'
import TimepickerOfRoom from '@/components/rooms/form/inputs/TimepickerOfRoom.vue'
import SelectFieldStock from '@/components/common/organims/SelectFieldStock.vue'

import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'FormOfRoom',

  components: {
    InputField,
    DatepickerOfRoom,
    TimepickerOfRoom,
    SelectFieldStock
  },

  props: {
    dialog: Boolean
  },

  computed: {
    ...mapGetters(['userId']),
    ...mapState({
      newRoom: (state) => state.newRoom,
      labelsOwner: (state) => state.labelsOwner,
      loading: (state) => state.loading
    })
  },

  async created() {
    const res = await this.$store.dispatch('getLabelOwner')

    if (!res || this.labelsOwner.length === 0) this.error = true
    else if (this.labelsOwner.length === 1) {
      this.stock = this.labelsOwner[0].ownerId
    }
  },

  data: () => ({
    valid: false,
    error: false,
    name: '',
    date: '',
    time: '',
    stock: ''
  }),

  methods: {
    changeValue(ob) {
      const { name, value } = ob
      this[name] = value
    },

    utcDate() {
      const date = this.date + ' ' + this.time
      const utcDate = moment(date).utcOffset(0)

      return moment(utcDate).format('YYYY-MM-DD HH:mm:ss')
    },

    toggleLoading(value) {
      this.$store.commit('TOGGLE_LOADING', value)
    },

    createPayload() {
      return {
        session_name: this.name,
        user_id: this.userId,
        appointment_date: this.utcDate(),
        owner_id: this.stock
      }
    },

    async createRoom(payload) {
      const res = await this.$store.dispatch('createRoomLive', payload)

      if (!res) return

      this.reset()
      await this.$store.dispatch('getRoomLive', this.userId)
      this.$mam.liveCreateRoom()
    },

    async validate() {
      if (!this.$refs.form.validate()) return

      this.toggleLoading(true)

      const payload = this.createPayload()

      await this.createRoom(payload)

      this.toggleLoading(false)
    },

    reset() {
      this.name = ''
      this.date = ''
      this.time = ''
      this.stock = ''
      this.$store.commit('TOGGLE_LOADING', false)
      this.$refs.form.reset()
      this.$emit('close-dialog')
    }
  }
}
</script>
